export const DEFAULT_CURRENCY = {
  code: 'USD',
  symbol: '$',
};

export const formatCurrency = (
  amount: number,
  currency: string = DEFAULT_CURRENCY.code,
  options?: Intl.NumberFormatOptions
) => {
  const isCAD = currency === 'CAD';
  const locale = isCAD ? 'en-CA' : 'en-US';
  const formatOptions: Intl.NumberFormatOptions = {
    style: 'currency',
    currency,
    currencyDisplay: 'symbol',
    maximumFractionDigits: 0,
    ...(isCAD && {
      currencyDisplay: 'code',
    }),
    ...options,
  };

  const formattedAmount = new Intl.NumberFormat(locale, formatOptions).format(
    amount
  );

  return formattedAmount;
};
